import { Button, IconButton, Stack, Typography, useMediaQuery } from "@mui/material"
import { IconQuestions } from "../../../../icons/IconQuestions"
import { IconOffers } from "../../../../icons/IconOffers"
import { IconOpinions } from "../../../../icons/IconOpinions"
import { MainStack } from "./style"
import { FormBlock } from "../../../../common/FormGenerator"
import { getFormConfig } from "./settingsConfig"
import { useFormContext } from "react-hook-form"
import { COLORS } from "../../../../styles/variables"
import { formatNumber } from "../../../../common/FormatNumber"
import { CommentsType } from "../../../../types/common"
import { IconClose } from "../../../../icons/IconClose"
import type { ProjectCommentTabCounts } from "../../../../api/types/projects"
import { PureLightTheme } from "../../../../styles/theme"

type CommentsFilterProps = {
    onClose?: () => void
    tabCounts?: ProjectCommentTabCounts
}

const defaultTabCounts: ProjectCommentTabCounts = { opinions: 0, suggestions: 0, questions: 0 }

export const CommentsFilter = ({ onClose, tabCounts = defaultTabCounts }: CommentsFilterProps) => {
    const isTablet = useMediaQuery('@media (max-width: 1150px)')
    const isCommentsDrawer = useMediaQuery(PureLightTheme.breakpoints.down("md"))
    const { setValue, watch } = useFormContext()
    const currentFilter = watch("filterType") as CommentsType

    const titles = {
        [CommentsType.questions]: "Вопросы",
        [CommentsType.suggestions]: "Предложения",
        [CommentsType.opinions]: "Мнения",
    }

    return (
        <Stack direction="column" gap={1}>
            {isTablet && (
                <Stack 
                    direction="row" 
                    alignItems="center" 
                    justifyContent="space-between"
                    width="100%"
                >
                    <Typography variant="h2">
                        {titles[currentFilter as CommentsType] || "Комментарии"}
                    </Typography>
                    {onClose && (
                        <IconButton onClick={onClose}>
                            <IconClose />
                        </IconButton>
                    )}
                </Stack>
            )}
            <Stack direction="row" sx={MainStack}>
                <Stack direction="row" gap={2} flex={1}>
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        startIcon={<IconOpinions />}
                        onClick={() => setValue("filterType", CommentsType.opinions)}
                        sx={{ color: currentFilter === CommentsType.opinions ? COLORS.BLACK : COLORS.GRANITE }}
                    >
                        {(!isTablet || currentFilter !== CommentsType.opinions) && "Мнения"} {formatNumber(tabCounts.opinions)}
                    </Button>
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        startIcon={<IconOffers />}
                        onClick={() => setValue("filterType", CommentsType.suggestions)}
                        sx={{ color: currentFilter === CommentsType.suggestions ? COLORS.BLACK : COLORS.GRANITE }}
                    >
                        {(!isTablet || currentFilter !== CommentsType.suggestions) && "Предложения"} {formatNumber(tabCounts.suggestions)}
                    </Button>
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        startIcon={<IconQuestions />}
                        onClick={() => setValue("filterType", CommentsType.questions)}
                        sx={{ color: currentFilter === CommentsType.questions ? COLORS.BLACK : COLORS.GRANITE }}
                    >
                        {(!isTablet || currentFilter !== CommentsType.questions) && "Вопросы"} {formatNumber(tabCounts.questions)}
                    </Button>
                </Stack>
                <Stack>
                    <FormBlock
                        formFieldConfig={getFormConfig("commentsSort", {
                            menuInModal: isCommentsDrawer,
                        })}
                    />
                </Stack>
            </Stack>
        </Stack>
    )
}
